const GConf = {

    // main variables
    ApiLink : 'https://api.abyedh.com/api/glsi/pf',  
    themeColor : '#068f2a',
    
    TostErrorGonf : {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored"
    },
    TostSuucessGonf : {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored"
    },
    TostInternetGonf : {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored"
    },
    LeafleftIcon : {
        iconUrl: require('leaflet/dist/images/position.gif'),
        iconSize: [10,10],
        shadowSize: [0,0],
        shadowUrl: '',
        shadowSize:   [0,0],
        iconAnchor:   [0,0],
        shadowAnchor: [0,0],
        popupAnchor:  [0,0]
    },

    matiereListe:[
        {id:1, nom:'Ai', matCol:'#0b872c',  nbSeances:3, nbPr : 1},
        {id:1, nom:'Compilation', matCol:'#870b28',  nbSeances:2, nbPr : 0},
        {id:1, nom:'Web', matCol:'#e6d70a',  nbSeances:2, nbPr : 2},
        {id:1, nom:'Iot', matCol:'#0075e2',  nbSeances:2, nbPr : 2},
        {id:1, nom:'Ad Reseaux', matCol:'#aa0cd1',  nbSeances:2, nbPr : 2},
        {id:1, nom:'Ad BD', matCol:'#f08812',  nbSeances:2, nbPr : 2},
        {id:1, nom:'Enterpot des donneé', matCol:'#331d31',  nbSeances:2, nbPr : 2},
        {id:1, nom:'Test Logiciel', matCol:'#da0000',  nbSeances:2, nbPr : 2},
        {id:1, nom:'Indexation et multimedia', matCol:'#008573',  nbSeances:2, nbPr : 2},
        {id:1, nom:'Anglais', matCol:'#58dd00',  nbSeances:2, nbPr : 2},
        {id:1, nom:'Droit', matCol:'#194586',  nbSeances:2, nbPr : 2},
        {id:1, nom:'Projet Federe', matCol:'#7e0548',  nbSeances:2, nbPr : 2},
    ],
    groupeListe:[
        {grid:100, spec:'2GLSI', grp:'GRP1'},
        {grid:101, spec:'2GLSI', grp:'GRP2'},
        {grid:102, spec:'2GLSI', grp:'GRP3'},
        {grid:103, spec:'2GLSI', grp:'GRP4'},

        {grid:104, spec:'2ISI', grp:'GRP1'},
        {grid:105, spec:'2ISI', grp:'GRP2'},

        {grid:106, spec:'2SC', grp:'GRP1'},
        {grid:107, spec:'2SC', grp:'GRP2'},
        {grid:108, spec:'2SC', grp:'GRP3'},

        {grid:109, spec:'2SE', grp:'GRP1'},
        {grid:110, spec:'2SE', grp:'GRP2'},
        {grid:111, spec:'2SE', grp:'GRP3'},
    ],
    salleListe:[
        {id:1, nom:'salle 1'},
        {id:2, nom:'salle 2'},
        {id:3, nom:'salle 4'},
        {id:4, nom:'salle 5'},
        {id:5, nom:'salle 5'},
        {id:6, nom:'salle 6'},
        {id:7, nom:'salle 7'},
        {id:8, nom:'salle 8'},
        {id:9, nom:'salle 9'},
        {id:10, nom:'salle 10'},
        {id:11, nom:'salle 11'},
        {id:12, nom:'salle 12'},
    ],
    horaireListe : [
        {id:1 , de:'08:15', vers:'09:45', hnom:'08:15 - 09:45'},
        {id:2 , de:'09:50', vers:'11:20', hnom:'09:50 - 11:20'},
        {id:3 , de:'11:25', vers:'12:55', hnom:'11:25 - 12:55'},
        {id:4 , de:'13:35', vers:'15:05', hnom:'13:35 - 15:05'},
        {id:5 , de:'15:10', vers:'16:40', hnom:'15:10 - 16:40'},
        {id:6 , de:'16:45', vers:'18:15', hnom:'16:45 - 18:15'},
    ],
    //data for test : 
    proffListe: [
    ]
}
 
export default GConf 